import { setPageStateById } from '@/contexts/PageContext/PageContext';

export const setShowMobileLeftMenu = (setState: setPageStateById) => (value: boolean) => {
  setState('SET_SHOW_MOBILE_LEFT_MENU', (s) => {
    return {
      ...s,
      showMobileLeftMenu: value,
      showMobilePageRightMenu: false,
    };
  });
};
